import Location from "./Location";
import PAAttendee from "./Attendee";


class Idea {
    constructor(){

        const _temp = PAAttendee.generateRandomString(24);
        this.temp_id = _temp;
        this.id = _temp;

        this.added_by = "";

        this.title = "";
        this.category = "";

        this.attendee_id = "";

        this.url = "";

        this.location = new Location();
        this.Place = {};
        this.photos = [];

        this.comments = [];

        this.status = 0;
    }
}

export default Idea;
